import { ArrowUpRight } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { useBrandModal } from "../context/BrandModalContext";
import { ASSETS } from "../i18n";

export const Footer = () => {
  const { t } = useLang();
  const { openModal } = useBrandModal();
  const year = new Date().getFullYear();

  const links = ["house", "origin", "operations", "standards", "responsibility", "trade"];

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="site-footer" className="relative overflow-hidden text-ivory">
      <img src={ASSETS.goldStone} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[#0d0d0a]/85" />
      <div className="relative max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div className="grid lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <img src={ASSETS.sealLight} alt="TOTUMO" className="h-16 w-auto mb-8 opacity-90" />
            <p className="font-serif text-2xl md:text-3xl font-light leading-snug max-w-md text-ivory/95">
              {t("footer.tagline")}
            </p>
          </div>

          <div className="lg:col-span-3 lg:col-start-7">
            <p className="font-sans text-[0.7rem] uppercase tracking-[0.25em] text-ivory/50 mb-6">{t("footer.nav")}</p>
            <ul className="space-y-3">
              {links.map((l) => (
                <li key={l}>
                  <button
                    data-testid={`footer-nav-${l}`}
                    onClick={() => go(l)}
                    className="font-sans text-sm text-ivory/80 hover:text-ivory transition-colors duration-500"
                  >
                    {t(`nav.${l}`)}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="font-sans text-[0.7rem] uppercase tracking-[0.25em] text-ivory/50 mb-6">{t("inquiries.office")}</p>
            <p className="font-sans text-sm text-ivory/85 leading-relaxed">{t("inquiries.officeValue")}</p>
            <button
              data-testid="footer-brand-system-link"
              type="button"
              onClick={openModal}
              className="group inline-flex items-center gap-3 mt-10 font-sans text-[0.7rem] uppercase tracking-[0.2em] border border-ivory/40 px-5 py-3 hover:bg-ivory hover:text-ink transition-all duration-500"
            >
              {t("footer.brandSystem")}
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
            </button>
            <p className="font-sans text-[0.65rem] text-ivory/40 mt-3 tracking-wide">{t("footer.brandSystemNote")}</p>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-ivory/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-sans text-xs tracking-[0.2em] text-ivory/50">© {year} TOTUMO · HOUSE OF GOLD</p>
          <p className="font-sans text-xs tracking-[0.15em] text-ivory/40">{t("footer.rights")}</p>
        </div>
      </div>
    </footer>
  );
};
